

import React, { useEffect, useState, useRef } from "react";
import SelectPopup from "./SelectPopup";
import "./DeliveryScreen.css";
import { getParties } from "./api/PartyApi";
import { getItems } from "./api/ItemApi";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const DELIVERY_API = "http://103.79.74.237:8081/api/deliveries";

/* ---------- EMPTY ROW ---------- */
const emptyRow = () => ({
  itemId: "",
  itemName: "",
  hsnCode: "",
  qty: "",
  rate: "",
  taxPercent: "",
  amount: "",
   totalWeightGrams: 0, 
  remarks: "",
});

function numberToWords(num) {
  const a = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  if (num === 0) return "Zero";

  function inWords(n) {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + " " + a[n % 10];
    if (n < 1000)
      return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
    if (n < 100000)
      return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
    return "";
  }

  return inWords(Math.floor(num)).trim();
}

export default function DeliveryScreen({goHome}) {

  /* ---------- MASTER ---------- */
  const [parties, setParties] = useState([]);
  const [items, setItems] = useState([]);
const [mobileTab, setMobileTab] = useState("list");
  /* ---------- PARTY POPUP ---------- */
  const [showPartyPopup, setShowPartyPopup] = useState(false);
  const [partySearch, setPartySearch] = useState("");
 const [activePartyIndex, setActivePartyIndex] = useState(0);
 const [showInvoicePartyPopup, setShowInvoicePartyPopup] = useState(false);
const [invoicePartySearch, setInvoicePartySearch] = useState("");
const invoiceActiveIndexRef = React.useRef(0);
const [invoiceActiveIndex, setInvoiceActiveIndex] = useState(0);
const invoiceInputRef = React.useRef(null);
const [selectedDcIndex, setSelectedDcIndex] = useState(null);
const [popupData, setPopupData] = useState([]);
const [popupTitle, setPopupTitle] = useState("");
// 🔥 PRINT STATE (NEW)
const [printData, setPrintData] = useState(null);
const [isPrinting, setIsPrinting] = useState(false);

// 🔥 MULTI SELECT (ids)
const [selectedDcIds, setSelectedDcIds] = useState([]);
// null = print all DCs

const [hideCaret, setHideCaret] = useState(false);
const [keyboardNav, setKeyboardNav] = useState(false);
const partyInputRef = useRef(null);
const [showPreview, setShowPreview] = useState(false);
/* ---------- DELIVERY POPUP ---------- */
const [showDeliveryPopup, setShowDeliveryPopup] = useState(false);
const [partyDeliveries, setPartyDeliveries] = useState([]);
const [popupIndex, setPopupIndex] = useState(0);
const [popup,setPopup] = useState({
open:false,
field:"",
title:"",
options:[],
allowAdd:false,
  rowIndex: null
});

useEffect(() => {
  if (showDeliveryPopup) {
    setSelectedDcIds([]);
    setSelectedDcIndex(null);
  }
}, [showDeliveryPopup]);

const sortedItems = [...items].sort((a, b) =>
  a.itemName.localeCompare(b.itemName)
);

  /* ---------- HEADER ---------- */
  const [header, setHeader] = useState({
    id: null,
    partyId: "",
    partyName: "",
    address: "",
    gstNo: "",
    dcNo: "",
    date: new Date().toISOString().slice(0, 10),
    poNo: "",
    type: "",
    vehicleNo: "",
    invoicePartyId: "",
    invoicePartyName: "",
    discount: 0,
    totalAmount: 0,
  });

  

  /* ---------- TABLE ---------- */
const [rows, setRows] = useState([
  emptyRow(),
  emptyRow(),
  emptyRow(),
  emptyRow(),
]);
const TABLE_FLOW = [0, 2, 5, 7]; 
// Item → Qty → Tax → Remarks


  /* ---------- RIGHT PANEL ---------- */
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  /* ---------- INITIAL LOAD ---------- */
  useEffect(() => {
    getParties().then(setParties);
    getItems().then(setItems);
    loadList();
    loadNextDc();
  }, []);

 const handlePopupSelect = (val) => {
  if (popup.field === "type") {
    setHeader(h => ({ ...h, type: val }));
  }

  if (popup.field === "item") {
    const item = items.find(it => it.itemName === val);
    if (item) {
      updateRow(popup.rowIndex, {
        itemId: item.id,
        itemName: item.itemName,
        hsnCode: item.hsnCode,
        rate: item.rate,
        taxPercent: item.taxPercent,
        unitValue: item.unitValue,
        unitType: item.unitType
      });
    }
  }
};
 async function loadNextDc() {
  const res = await fetch(`${DELIVERY_API}/next-dc`);
  const dc = await res.json();   // ✅ await here
  setHeader(h => ({ ...h, dcNo: dc }));
}


  async function loadList() {
    const res = await fetch(DELIVERY_API);
    setList(await res.json());
  }

  /* ---------- ITEM LOGIC ---------- */
  function onItemSelect(i, itemId) {
    const it = items.find(x => String(x.id) === itemId);
    if (!it) return;

    updateRow(i, {
      itemId: it.id,
      itemName: it.itemName,
      hsnCode: it.hsnCode,
      rate: it.rate,
      taxPercent: it.taxPercent,
        unitValue: it.unitValue,
  unitType: it.unitType
    });
  }

  
  function updateRow(i, changes) {
    setRows(rows =>
      rows.map((r, idx) => {
        if (idx !== i) return r;
        const next = { ...r, ...changes };
        const qty = Number(next.qty || 0);
        const rate = Number(next.rate || 0);
        const tax = qty * rate * (Number(next.taxPercent || 0) / 100);
        next.amount = (qty * rate + tax).toFixed(2);
const unitValue = Number(next.unitValue || 0);
const totalUnit = unitValue * qty;

next.totalKgDisplay = totalUnit + " " + (next.unitType || "");
next.totalWeightGrams = totalUnit;
  return next;
      })
    );
  }

  function addNewRow() {
  setRows(prev => [...prev, emptyRow()]);
}

function handleTableEnter(e, rowIndex, colIndex) {
  const key = e.key;
  const maxRow = rows.length - 1;
  const flowIndex = TABLE_FLOW.indexOf(colIndex);

  // ================= ENTER =================
  if (key === "Enter") {
    e.preventDefault();

    if (flowIndex === -1) return;

    const isLastField = flowIndex === TABLE_FLOW.length - 1;
    const isLastRow = rowIndex === maxRow;

    // 🔥 If Remarks → go to next row Item
    if (isLastField) {
      if (isLastRow) {
        addNewRow();
      }

      requestAnimationFrame(() => {
        const next = document.querySelector(
          `[data-row="${rowIndex + 1}"][data-col="0"]`
        );
        next?.focus();
      });

      return;
    }

    // 🔁 Move to next manual column
    const nextCol = TABLE_FLOW[flowIndex + 1];

    const next = document.querySelector(
      `[data-row="${rowIndex}"][data-col="${nextCol}"]`
    );
    next?.focus();

    return;
  }

  // ================= ARROW DOWN =================
  if (key === "ArrowDown") {
    e.preventDefault();
    if (rowIndex < maxRow) {
      const next = document.querySelector(
        `[data-row="${rowIndex + 1}"][data-col="${colIndex}"]`
      );
      next?.focus();
    }
    return;
  }

  // ================= ARROW UP =================
  if (key === "ArrowUp") {
    e.preventDefault();
    if (rowIndex > 0) {
      const prev = document.querySelector(
        `[data-row="${rowIndex - 1}"][data-col="${colIndex}"]`
      );
      prev?.focus();
    }
    return;
  }

  // ================= ARROW RIGHT =================
  if (key === "ArrowRight") {
    e.preventDefault();
    const nextCol = TABLE_FLOW[flowIndex + 1];
    if (nextCol !== undefined) {
      const next = document.querySelector(
        `[data-row="${rowIndex}"][data-col="${nextCol}"]`
      );
      next?.focus();
    }
    return;
  }

  // ================= ARROW LEFT =================
  if (key === "ArrowLeft") {
    e.preventDefault();
    const prevCol = TABLE_FLOW[flowIndex - 1];
    if (prevCol !== undefined) {
      const prev = document.querySelector(
        `[data-row="${rowIndex}"][data-col="${prevCol}"]`
      );
      prev?.focus();
    }
  }
}

  /* ---------- TOTAL ---------- */
  useEffect(() => {
    const sum = rows.reduce((t, r) => t + Number(r.amount || 0), 0);
    setHeader(h => ({ ...h, totalAmount: sum.toFixed(2) }));
  }, [rows]);

  /* ---------- SAVE ---------- */
  async function handleSave() {

  const payload = {
    ...header,
    deliveryDate: header.date,

    items: rows
     .filter(r => r.itemId && String(r.itemId).trim() !== "" && r.qty && Number(r.qty) > 0)
      .map(r => ({
        
        itemId: r.itemId,
        itemName: r.itemName,
        hsnCode: r.hsnCode,
        qty: r.qty,
        rate: r.rate,
        taxPercent: r.taxPercent,
        amount: r.amount,
        remarks: r.remarks,
        totalWeightGrams: r.totalWeightGrams,
         unitType: r.unitType
      }))
  };

  const method = header.id ? "PUT" : "POST";
  const url = header.id ? `${DELIVERY_API}/${header.id}` : DELIVERY_API;

  const res = await fetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

if (!res.ok) {
  if (res.status === 500) {
    alert("Insufficient stock");
  } else {
    const errorText = await res.text();
    alert(errorText);
  }
  return;

  }

  const saved = await res.json();

  setList(prev => [saved, ...prev.filter(d => d.id !== saved.id)]);
  alert("Saved successfully");

  handleNew();
}
  async function loadDelivery(id, doPrint = false) {
  const res = await fetch(`${DELIVERY_API}/${id}`);
  const d = await res.json();

  setHeader({
    id: d.id,
    partyId: d.partyId,
    partyName: d.partyName,
    address: d.address || "",
    gstNo: d.gstNo || "",
    dcNo: d.dcNo,
    date: d.deliveryDate,
    poNo: d.poNo || "",
    type: d.type || "",
    vehicleNo: d.vehicleNo || "",
    invoicePartyId: d.invoicePartyId || "",
    invoicePartyName: d.invoicePartyName || "",
    discount: d.discount || 0,
    totalAmount: d.totalAmount || 0,
  });

setRows(
  Array.from({ length: 8 }, (_, i) => {

    const it = d.items[i];
    if (!it) return emptyRow();

    const itemMaster = items.find(
      x => String(x.id) === String(it.itemId)
    );

    const unitValue = itemMaster?.unitValue || 0;
    const unitType = itemMaster?.unitType || "";

    const qty = Number(it.qty || 0);
    const totalUnit = unitValue * qty;

    return {
      ...it,
      unitValue,
      unitType,
      totalWeightGrams: totalUnit,
      totalKgDisplay: totalUnit + " " + unitType
    };

  })
);
  setSelectedId(id);

  // 🔥 SAFE PRINT
  if (doPrint) {
    requestAnimationFrame(() => window.print());
  }
}



  function handleNew() {
    setHeader({
      id: null,
      partyId: "",
      partyName: "",
      address: "",
      gstNo: "",
      dcNo: "",
      date: new Date().toISOString().slice(0, 10),
      poNo: "",
      type: "",
      vehicleNo: "",
      invoicePartyId: "",
      invoicePartyName: "",
      discount: 0,
      totalAmount: 0,
    });
    setRows(Array.from({ length: 8 }, emptyRow));
    setSelectedId(null);
    loadNextDc();
  }

  

  /* ---------- RIGHT LIST FILTER ---------- */
  const filteredList = list.filter(d => {
    if (search && !d.partyName.toLowerCase().includes(search.toLowerCase()))
      return false;
    if (fromDate && d.deliveryDate < fromDate) return false;
    if (toDate && d.deliveryDate > toDate) return false;
    return true;
  });

  const filteredParties = parties
  .filter(p =>
    `${p.partyName} ${p.place || ""} ${p.mobile || ""}`
      .toLowerCase()
      .includes(partySearch.toLowerCase())
  )
  .sort((a, b) => a.partyName.localeCompare(b.partyName));

  /* ---------- PARTY SELECT ---------- */
function selectParty(p) {
  if (!p) return;

  setHeader(h => ({
    ...h,
    partyId: p.id,
    partyName: p.partyName,
    address: p.address || "",
    phone: p.mobile || "",
    gstNo: p.gstin || "",

    // 🔥 NEW AUTO COPY TO DELIVERY PARTY
    invoicePartyId: p.id,
    invoicePartyName: p.partyName,
    invoiceGstNo: p.gstin || ""
  }));

  setShowPartyPopup(false);
  setPartySearch("");
  setActivePartyIndex(0);
}


function selectInvoiceParty(p) {
  if (!p) return;

  setHeader(h => ({
    ...h,
    invoicePartyId: p.id,
    invoicePartyName: p.partyName,
    invoiceGstNo: p.gstin || "",
  }));

  setShowInvoicePartyPopup(false);
  setInvoicePartySearch("");
  invoiceActiveIndexRef.current = 0;
}
const filteredInvoiceParties = parties
  .filter(p =>
    `${p.partyName} ${p.place || ""} ${p.mobile || ""}`
      .toLowerCase()
      .includes(invoicePartySearch.toLowerCase())
  )
  .sort((a, b) => a.partyName.localeCompare(b.partyName));


async function loadPartyDeliveries(partyName) {
  const res = await fetch(
    `${DELIVERY_API}?partyName=${encodeURIComponent(partyName)}`
  );
  const deliveries = await res.json();

  if (!deliveries.length) return;

  // 🔥 merge all items
  const allItems = deliveries.flatMap(d => d.items || []);

  setHeader(h => ({
    ...h,
    id: null,                 // multi-mode (not editing single DC)
    partyId: deliveries[0].partyId,
    partyName: deliveries[0].partyName,
    address: deliveries[0].address || "",
    gstNo: deliveries[0].gstNo || "",
    dcNo: "MULTI",             // 👈 important
    totalAmount: deliveries.reduce(
      (s, d) => s + Number(d.totalAmount || 0), 0
    ).toFixed(2)
  }));

  setRows(
    Array.from({ length: Math.max(8, allItems.length) }, (_, i) =>
      allItems[i]
        ? {
            itemId: allItems[i].itemId,
            itemName: allItems[i].itemName,
            hsnCode: allItems[i].hsnCode,
            qty: allItems[i].qty,
            rate: allItems[i].rate,
            taxPercent: allItems[i].taxPercent,
            amount: allItems[i].amount,
            remarks: allItems[i].remarks || ""
          }
        : emptyRow()
    )
  );
}

/* ---------- PARTY KEYBOARD NAVIGATION ---------- */
function handlePartyKeyDown(e) {
  if (!filteredParties.length) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();

    // 🔥 remove caret + bg by blur
    partyInputRef.current.blur();

    setActivePartyIndex(i =>
      Math.min(i + 1, filteredParties.length - 1)
    );

    // 🔥 refocus without caret
    requestAnimationFrame(() => {
      partyInputRef.current.focus({ preventScroll: true });
    });
    return;
  }

  if (e.key === "ArrowUp") {
    e.preventDefault();

    partyInputRef.current.blur();

    setActivePartyIndex(i =>
      Math.max(i - 1, 0)
    );

    requestAnimationFrame(() => {
      partyInputRef.current.focus({ preventScroll: true });
    });
    return;
  }

  if (e.key === "Enter") {
    e.preventDefault();
    selectParty(filteredParties[activePartyIndex]);
  }

  if (e.key === "Escape") {
    setShowPartyPopup(false);
  }
}

function handleInvoicePartyKeyDown(e) {
  if (!filteredInvoiceParties.length) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    setInvoiceActiveIndex(i =>
      Math.min(i + 1, filteredInvoiceParties.length - 1)
    );
  }

  if (e.key === "ArrowUp") {
    e.preventDefault();
    setInvoiceActiveIndex(i => Math.max(i - 1, 0));
  }

  if (e.key === "Enter") {
    e.preventDefault();
    selectInvoiceParty(filteredInvoiceParties[invoiceActiveIndex]);
  }

  if (e.key === "Escape") {
    setShowInvoicePartyPopup(false);
  }
}

function focusNext(e) {
  if (e.key !== "Enter") return;

  e.preventDefault();

  const form = e.target.closest("form") || document;
  const focusable = Array.from(
    form.querySelectorAll(
      'input:not([disabled]):not([readonly]), select:not([disabled]), textarea:not([disabled])'
    )
  );

  const index = focusable.indexOf(e.target);
  if (index > -1 && focusable[index + 1]) {
    focusable[index + 1].focus();
  }
}


  /* ---------- MERGED DELIVERY LIST (SAME CLASSES) ---------- */
const mergedList = Object.values(
  filteredList.reduce((acc, d) => {
    if (!acc[d.partyName]) {
      acc[d.partyName] = {
        id: d.id,
        partyName: d.partyName,
        deliveryDate: d.deliveryDate,
        totalAmount: Number(d.totalAmount || 0),
      };
    } else {
      acc[d.partyName].totalAmount += Number(d.totalAmount || 0);
    }
    return acc;
  }, {})
).sort((a, b) =>
  a.partyName.localeCompare(b.partyName, "en", { sensitivity: "base" })
);

async function openDeliveryPopup(partyName) {
  const res = await fetch(
    `${DELIVERY_API}?partyName=${encodeURIComponent(partyName)}`
  );
  const data = await res.json();

  // 🔥 Extra frontend safety filter
  const filtered = data.filter(d =>
    d.partyName.toLowerCase() === partyName.toLowerCase()
  );

  if (!filtered.length) return;

  const sorted = [...filtered].sort(
    (a, b) => Number(b.dcNo) - Number(a.dcNo)  // DESC ✅
  );

  setPopupData(sorted);
  setPopupTitle(`DC List — ${partyName}`);
  setSelectedDcIds([]);
  setShowDeliveryPopup(true);
}
function openAllDcPopup() {
  if (!list.length) {
    alert("No DC available");
    return;
  }

  const sorted = [...list].sort(
  (a, b) => Number(b.dcNo) - Number(a.dcNo)  // DESC ✅
);

  setPopupData(sorted);
  setPopupTitle("DC List — All");
  setSelectedDcIds([]);
  setShowDeliveryPopup(true);
}
function mergeItemsFromDeliveries(deliveries = []) {

  const map = {};

  deliveries
    .filter(Boolean)
    .forEach(dc => {

      if (!Array.isArray(dc.items)) return;

      dc.items.forEach(it => {

        const key = [
          it.itemId,
          it.hsnCode,
          it.rate,
          it.taxPercent
        ].join("|");

        if (!map[key]) {

          map[key] = {
              itemId: it.itemId,
            itemName: it.itemName,
            hsnCode: it.hsnCode,
            qty: Number(it.qty || 0),
            rate: Number(it.rate || 0),
            taxPercent: Number(it.taxPercent || 0),
            amount: Number(it.amount || 0),

            totalWeightGrams: Number(it.totalWeightGrams || 0),
            unitType: it.unitType || ""
          };

        } else {

          map[key].qty += Number(it.qty || 0);
          map[key].amount += Number(it.amount || 0);
          map[key].totalWeightGrams += Number(it.totalWeightGrams || 0);

        }

      });

    });

  return Object.values(map);
}
const openSelect = rowIndex => {
  setRows(prev =>
    prev.map((r, i) =>
      i === rowIndex ? { ...r, open: true } : r
    )
  );
};

const closeSelect = rowIndex => {
  setRows(prev =>
    prev.map((r, i) =>
      i === rowIndex ? { ...r, open: false } : r
    )
  );
};

/* ================= PRINT CALCULATIONS ================= */
const printBillAmount = printData
  ? printData.items.reduce((s, it) => {
      const qty = Number(it.qty || 0);
      const rate = Number(it.rate || 0);
      const tax = qty * rate * (Number(it.taxPercent || 0) / 100);
      return s + qty * rate + tax;
    }, 0)
  : 0;

const printDiscount = Number(header.discount || 0);
const printTotalAmount = printBillAmount - printDiscount;

const totalQty = rows.reduce(
  (sum, r) => sum + Number(r.qty || 0),
  0
);

const totalTax = rows.reduce((sum, r) => {
  const qty = Number(r.qty || 0);
  const rate = Number(r.rate || 0);
  const taxPercent = Number(r.taxPercent || 0);
  return sum + (qty * rate * taxPercent / 100);
}, 0);

const billAmount = rows.reduce(
  (sum, r) => sum + (Number(r.qty || 0) * Number(r.rate || 0)),
  0
);

const grandAmount = billAmount + totalTax;

const finalTotal = grandAmount - Number(header.discount || 0);
const totalKg = rows.reduce(
  (sum, r) => sum + Number(r.totalWeightGrams || 0),
  0
);



const handleWhatsappSelected = async () => {

  // Must select exactly one DC
  if (selectedDcIds.length !== 1) {
    alert("Please select exactly one DC");
    return;
  }

  const dcId = selectedDcIds[0];
  const delivery = popupData.find(d => d.id === dcId);
  if (!delivery) {
    alert("DC not found");
    return;
  }

  // Get party info (for phone number)
  const party = parties.find(p => p.id === delivery.partyId) || {};

  if (!party.mobileNo) {
    alert("WhatsApp number not available for this party.\nPlease add it in Party Master.");
    return;
  }

  // Format phone: ensure 91XXXXXXXXXX
  let phone = party.mobileNo.replace(/\D/g, "");
  if (phone.length === 10) {
    phone = "91" + phone;
  }

  try {

    // ── STEP A: Generate PDF ──
    alert("Generating PDF...");
    const pdf = generateDeliveryPDF(delivery, party, items);
    const pdfBlob = pdf.output("blob");

    // ── STEP B: Upload PDF to Meta ──
    const formData = new FormData();
    formData.append(
      "file",
      pdfBlob,
      `DC_${delivery.dcNo}_${delivery.partyName}.pdf`
    );

    const uploadRes = await fetch(
      "http://103.79.74.237:8081/api/whatsapp/upload-media",
      { method: "POST", body: formData }
    );

    if (!uploadRes.ok) {
      const err = await uploadRes.text();
      alert("PDF upload failed: " + err);
      return;
    }

    const uploadData = await uploadRes.json();
    const mediaId = uploadData.id;

    if (!mediaId) {
      alert("Failed to get media ID from Meta");
      return;
    }

    // ── STEP C: Send WhatsApp message ──
    const sendRes = await fetch(
      "http://103.79.74.237:8081/api/whatsapp/send",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone: phone,
          mediaId: mediaId,
          dcNo: String(delivery.dcNo),
          partyName: delivery.partyName
        })
      }
    );

    if (sendRes.ok) {
      alert(`✅ WhatsApp PDF sent successfully to ${delivery.partyName}!`);
      setShowDeliveryPopup(false);
      setSelectedDcIds([]);
    } else {
      const err = await sendRes.text();
      alert("❌ WhatsApp send failed: " + err);
    }

  } catch (err) {
    console.error("WhatsApp error:", err);
    alert("Error: " + err.message);
  }
};



// ══════════════════════════════════════════════════════

// ══════════════════════════════════════════════════════════════
// REPLACE your entire generateDeliveryPDF function with this
// Matches the exact ERP bill format shown in DeliveryScreen
// ══════════════════════════════════════════════════════════════

// ══════════════════════════════════════════════════════════════
// REPLACE your entire generateDeliveryPDF function with this
// Clean v3 — proper alignment, spacing, full-width table
// ══════════════════════════════════════════════════════════════

function numberToWordsPDF(num) {
  const a = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine",
    "Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen",
    "Seventeen","Eighteen","Nineteen"];
  const b = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
  function inWords(n) {
    if (n === 0) return "";
    if (n < 20) return a[n] + " ";
    if (n < 100) return b[Math.floor(n/10)] + " " + a[n%10] + " ";
    if (n < 1000) return a[Math.floor(n/100)] + " Hundred " + inWords(n%100);
    if (n < 100000) return inWords(Math.floor(n/1000)) + "Thousand " + inWords(n%1000);
    if (n < 10000000) return inWords(Math.floor(n/100000)) + "Lakh " + inWords(n%100000);
    return inWords(Math.floor(n/10000000)) + "Crore " + inWords(n%10000000);
  }
  if (num === 0) return "Zero";
  return inWords(Math.floor(num)).trim();
}

function generateDeliveryPDF(delivery, party, items) {
  const doc  = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const pW   = doc.internal.pageSize.getWidth();   // 210
  const pH   = doc.internal.pageSize.getHeight();  // 297
  const L    = 7;   // left margin
  const R    = pW - 7; // right margin
  const CW   = R - L; // content width = 196mm

  const TEAL = [0, 128, 128];

  // ── OUTER BORDER ──
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.8);
  doc.rect(L - 2, 4, CW + 4, pH - 8);

  // ════════════════════════════════════════
  // HEADER
  // ════════════════════════════════════════
  // GSTIN (left)
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(60, 60, 60);
  doc.text("GSTIN : 33CLPWM2106A1ZG", L, 12);

  // Phone (right)
  doc.text("Cell : +91 8300045544 / +91 9965647744", R, 12, { align: "right" });

  // Company name (center)
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(220, 80, 0);
  doc.text("ORANGE TRADINGS", pW / 2, 20, { align: "center" });

  // Sub-title (center)
  doc.setFontSize(7.5);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(60, 60, 60);
  doc.text("(Naga Maida, Atta, Rava Whole Sale Dealer)", pW / 2, 25, { align: "center" });
  doc.text("Dharapuram Road, Tiruppur \u2013 641 608", pW / 2, 30, { align: "center" });

  // Header divider
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.6);
  doc.line(L - 2, 33, R + 2, 33);

  // ════════════════════════════════════════
  // MID: Party Info (left) | Invoice Box (right)
  // ════════════════════════════════════════
  const midTop = 35;
  const midH   = 30;

  // Party Info
  doc.setFontSize(8.5);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0);
  doc.text("To M/s :", L, midTop + 5);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(delivery.partyName || "", L, midTop + 11);
  doc.text("Phone : " + (party.mobileNo || "-"), L, midTop + 17);
  doc.text("Gst No : " + (party.gstin || "CUSTOMER"), L, midTop + 23);

  // Invoice Box (right half)
  const invX = pW / 2 + 4;
  const invW = R - invX;
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.4);
  doc.rect(invX, midTop, invW, midH);

  // INVOICE title bar
  doc.setFillColor(...TEAL);
  doc.rect(invX, midTop, invW, 7, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);
  doc.text("INVOICE", invX + invW / 2, midTop + 5, { align: "center" });

  // Customer name
  doc.setFontSize(7.5);
  doc.setTextColor(0);
  doc.setFont("helvetica", "normal");
  doc.text("Customer : " + (delivery.partyName || ""), invX + 3, midTop + 12);

  // No | Date header
  doc.setFillColor(210, 240, 240);
  doc.rect(invX, midTop + 14, invW / 2, 5, "F");
  doc.rect(invX + invW / 2, midTop + 14, invW / 2, 5, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.5);
  doc.setTextColor(0, 80, 80);
  doc.text("No", invX + invW / 4, midTop + 18, { align: "center" });
  doc.text("Date", invX + invW * 3 / 4, midTop + 18, { align: "center" });

  // Dividers inside box
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.3);
  doc.line(invX + invW / 2, midTop + 14, invX + invW / 2, midTop + midH);
  doc.line(invX, midTop + 14, invX + invW, midTop + 14);
  doc.line(invX, midTop + 19, invX + invW, midTop + 19);

  // DC No | Date values
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text(String(delivery.dcNo),
    invX + invW / 4, midTop + 25, { align: "center" });
  doc.text(
    new Date(delivery.deliveryDate).toLocaleDateString("en-GB"),
    invX + invW * 3 / 4, midTop + 25, { align: "center" }
  );

  // Divider below mid section
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.4);
  doc.line(L - 2, midTop + midH + 2, R + 2, midTop + midH + 2);

  // ════════════════════════════════════════
  // ITEMS TABLE — full width, clean columns
  // ════════════════════════════════════════
  // Column widths must add up to CW (196mm)
  // S.No(8)+Particulars(56)+HSN(24)+Qty(13)+U/A(24)+Rate(22)+Tax(13)+Amount(24) = 184
  // We'll use tableWidth = CW and let autoTable distribute

  const tableStartY = midTop + midH + 4;

  const tableRows = (delivery.items || []).map((it, i) => {
    const qty  = Number(it.qty  || 0);
    const rate = Number(it.rate || 0);
    const tax  = qty * rate * (Number(it.taxPercent || 0) / 100);
    const amt  = qty * rate + tax;
    const ua   = Number(it.totalWeightGrams || 0);
    const itemMaster = (items || []).find(x => String(x.id) === String(it.itemId));
    const unit = itemMaster ? (itemMaster.unitType || "") : "";
    return [
      i + 1,
      it.itemName || "",
      it.hsnCode  || "",
      qty,
      ua.toFixed(2) + " " + unit,
      rate.toFixed(2),
      (it.taxPercent || 0) + "%",
      amt.toFixed(2)
    ];
  });

  autoTable(doc, {
    startY: tableStartY,
    margin: { left: L, right: 7 },
    tableWidth: CW,
    head: [["S.No", "PARTICULARS", "HSN", "QTY", "U/A", "RATE", "TAX", "AMOUNT"]],
    body: tableRows,
    styles: {
      fontSize: 8,
      cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
      lineColor: TEAL,
      lineWidth: 0.25,
      textColor: [0, 0, 0],
      valign: "middle"
    },
    headStyles: {
      fillColor: TEAL,
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: 8,
      halign: "center",
      cellPadding: 2.5
    },
    alternateRowStyles: {
      fillColor: [240, 252, 252]
    },
    columnStyles: {
      0: { cellWidth: 10,  halign: "center" },
      1: { cellWidth: 54,  halign: "left"   },
      2: { cellWidth: 24,  halign: "center" },
      3: { cellWidth: 13,  halign: "right"  },
      4: { cellWidth: 25,  halign: "right"  },
      5: { cellWidth: 22,  halign: "right"  },
      6: { cellWidth: 13,  halign: "right"  },
      7: { cellWidth: 25,  halign: "right"  },
    },
    tableLineColor: TEAL,
    tableLineWidth: 0.3
  });

  // ════════════════════════════════════════
  // TOTALS SECTION
  // ════════════════════════════════════════
  const tableEndY = (doc.lastAutoTable ? doc.lastAutoTable.finalY : 180);
  const totTop    = tableEndY + 6;  // 6mm gap after table

  // Calculate
  const billAmt = (delivery.items || []).reduce((s, it) => {
    const q = Number(it.qty  || 0);
    const r = Number(it.rate || 0);
    const t = q * r * (Number(it.taxPercent || 0) / 100);
    return s + q * r + t;
  }, 0);
  const totTax = (delivery.items || []).reduce((s, it) => {
    const q = Number(it.qty  || 0);
    const r = Number(it.rate || 0);
    return s + q * r * (Number(it.taxPercent || 0) / 100);
  }, 0);
  const discount    = Number(delivery.discount || 0);
  const totalAmount = billAmt - discount;

  // Right-side totals box
  const totBoxX = pW / 2 + 4;
  const totBoxW = R - totBoxX;
  const totBoxH = 18;

  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.3);
  doc.rect(totBoxX, totTop, totBoxW, totBoxH);

  // Horizontal dividers inside totals box
  doc.line(totBoxX, totTop + 6, totBoxX + totBoxW, totTop + 6);
  doc.line(totBoxX, totTop + 12, totBoxX + totBoxW, totTop + 12);

  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0);
  doc.text("Discount : " + discount.toFixed(2),  R - 2, totTop + 4.5,  { align: "right" });
  doc.text("Tot Tax : "  + totTax.toFixed(2),     R - 2, totTop + 10.5, { align: "right" });
  doc.text("Bill Amnt : " + billAmt.toFixed(2),   R - 2, totTop + 16.5, { align: "right" });

  // Rupees full-width row
  const rupY = totTop + totBoxH + 1;
  doc.setFillColor(220, 245, 245);
  doc.rect(L - 2, rupY, CW + 4, 8, "F");
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.3);
  doc.rect(L - 2, rupY, CW + 4, 8);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text(
    "Rupees : " + numberToWordsPDF(Math.round(totalAmount)) + " only.",
    L + 1, rupY + 5.5
  );
  doc.text("Total Amnt : " + totalAmount.toFixed(2), R, rupY + 5.5, { align: "right" });

  // ════════════════════════════════════════
  // FOOTER — fixed at bottom of page
  // ════════════════════════════════════════
  const footTop  = rupY + 12;        // Start of footer section
  const signY    = pH - 14;          // Fixed sign line near bottom
  const midLineX = pW / 2;

  // Footer border box
  doc.setDrawColor(...TEAL);
  doc.setLineWidth(0.3);
  doc.rect(L - 2, footTop, CW + 4, pH - footTop - 4);

  // Vertical divider
  doc.line(midLineX, footTop, midLineX, pH - 4);

  // Left: Terms
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  doc.setTextColor(50);
  doc.text("1. We are not responsible for any loss or damage in transit.", L, footTop + 7);
  doc.text("2. Please check quality and quantity before consumption.",     L, footTop + 13);
  doc.text("3. Payment after due date attracts interest @ 24% P.A.",      L, footTop + 19);
  doc.text("4. Subject to Tiruppur Jurisdiction.",                         L, footTop + 25);

  // Sign line left
  doc.setDrawColor(100);
  doc.setLineWidth(0.2);
  doc.line(L, signY, midLineX - 4, signY);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  doc.setTextColor(0);
  doc.text("Prepared By", L, signY + 4);
  doc.text("Receivers Sign", midLineX - 20, signY + 4);

  // Right: GST note + Auth sign
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  doc.setTextColor(50);
  doc.text(
    "We hereby certify that the company registration under",
    midLineX + 4, footTop + 7
  );
  doc.text("GST Act 2017 is in force and this transaction is", midLineX + 4, footTop + 12);
  doc.text("covered under this bill.",                          midLineX + 4, footTop + 17);

  // Auth sign
  doc.setDrawColor(100);
  doc.line(midLineX + 4, signY, R, signY);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text("For ORANGE TRADINGS",  R, signY - 6, { align: "right" });
  doc.text("Authorised Signatory", R, signY + 4, { align: "right" });

  return doc;
}
function handlePrintList() {
  const rowsToPrint = selectedDcIds.length > 0
    ? popupData.filter(d => selectedDcIds.includes(d.id))
    : popupData;

  if (!rowsToPrint.length) return alert("No DC to print");

  const totalQtyAll  = rowsToPrint.reduce((s, d) =>
    s + (d.items || []).reduce((a, it) => a + Number(it.qty || 0), 0), 0);
  const totalUAAll   = rowsToPrint.reduce((s, d) =>
    s + (d.items || []).reduce((a, it) => a + Number(it.totalWeightGrams || 0), 0), 0);
  const totalAmtAll  = rowsToPrint.reduce((s, d) =>
    s + Number(d.totalAmount || 0), 0);

  const win = window.open("", "_blank");
  win.document.write(`
    <html><head><title>DC List</title>
    <style>
      body { font-family: Arial, sans-serif; padding: 20px; font-size: 13px; }
      .header-section { position: relative; margin-bottom: 15px; }
      .company-section { text-align: center; }
      .title { font-size: 20px; font-weight: bold; }
      .sub-title { font-size: 13px; margin-top: 4px; }
      .date-section { position: absolute; right: 0; top: 0; text-align: right; font-weight: bold; font-size: 13px; }
      .report-title { text-align: center; font-weight: bold; font-size: 15px; margin: 10px 0 6px; }
      .report-wrapper { border: 2px solid #000; padding: 10px; }
      table { width: 100%; border-collapse: collapse; }
      th, td { border: 1px solid #000; padding: 5px 7px; font-size: 13px; }
      th { background: #eaeaea; text-align: center; }
      td { text-align: center; }
      td:nth-child(4) { text-align: left; }
      tfoot td { font-weight: bold; background: #f0f0f0; }
    </style>
    </head><body>
    <div class="report-wrapper">
      <div class="header-section">
        <div class="company-section">
          <div class="title">ORANGE TRADINGS</div>
          <div class="sub-title">DHARAPURAM ROAD, TIRUPUR - 641 601</div>
        </div>
        <div class="date-section">
          Date : ${new Date().toLocaleDateString("en-GB")}
        </div>
      </div>
      <div class="report-title">${popupTitle}</div>
      <table>
        <thead>
          <tr>
            <th>DC No</th>
            <th>Date</th>
            <th>Party</th>
            <th>Qty</th>
            <th>U/A</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          ${rowsToPrint.map(d => {
            const qty = (d.items || []).reduce((s, it) => s + Number(it.qty || 0), 0);
            const ua  = (d.items || []).reduce((s, it) => s + Number(it.totalWeightGrams || 0), 0);
            return `
              <tr>
                <td>${d.dcNo}</td>
                <td>${d.deliveryDate}</td>
                <td style="text-align:left">${d.partyName}</td>
                <td>${qty}</td>
                <td>${ua}</td>
                <td>${Number(d.totalAmount || 0).toFixed(2)}</td>
              </tr>`;
          }).join("")}
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3">Total</td>
            <td>${totalQtyAll}</td>
            <td>${totalUAAll}</td>
            <td>${totalAmtAll.toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    </body></html>
  `);
  win.document.close();
  win.onload = () => { win.focus(); win.print(); win.close(); };
}
// ══════════════════════════════════════════════════════
  /* ---------- UI ---------- */
  return (
    <div className="del-root">
      <div className="del-title">DELIVERY</div>

     <div className={`del-content ${mobileTab === "entry" ? "show-entry" : "show-list"}`}>
        {/* LEFT */}
        <div className="del-left">
          <div className="del-card">

            <div className="del-card-header">Delivery Entry</div>

            {/* ROW 1 */}
<div className="del-header-row">
  <div className="del-field">
    <label>Party Name</label>
    <input
      className="del-input"
      placeholder="Click to search party"
      value={header.partyName}
      readOnly
      onClick={() => setShowPartyPopup(true)}
    />
  </div>

  <div className="del-field">
    <label>D.C No</label>
    <input className="del-input" value={header.dcNo} disabled />
  </div>

  <div className="del-field">
    <label>Date</label>
    <input
      className="del-input"
      type="date"
      value={header.date}
      onChange={e => setHeader(h => ({ ...h, date: e.target.value }))}
    />
  </div>
</div>

{/* ROW 2 */}
<div className="del-header-row">
  <div className="del-field span-2">
    <label>Address</label>
    <input
      className="del-input"
      value={header.address}
      readOnly
      onKeyDown={focusNext}
    />
  </div>

  <div className="del-field">
    <label>PO No</label>
    <input
      className="del-input"
      value={header.poNo}
      onChange={e => setHeader(h => ({ ...h, poNo: e.target.value }))}
      onKeyDown={focusNext}
    />
  </div>

<div className="del-field">
<label>Type</label>

<input
className="del-input"
value={header.type}
placeholder="Select Type"
readOnly
onClick={()=>{
setPopup({
open:true,
field:"type",
title:"Select Type",
options:["Cash","Credit"],
allowAdd:false
});
}}
/>

</div>
</div>

{/* ROW 3 */}
<div className="del-header-row">
  <div className="del-field">
    <label className="del-label invoice">Delivery Party</label>
    <input
      className="del-input"
      placeholder="Click to select invoice party"
      value={header.invoicePartyName || ""}
      readOnly
      onClick={() => setShowInvoicePartyPopup(true)}
      onKeyDown={focusNext}
    />
  </div>

  <div className="del-field">
    <label>Vehicle No</label>
    <input
      className="del-input"
      value={header.vehicleNo || ""}
      onChange={e =>
        setHeader(h => ({ ...h, vehicleNo: e.target.value }))
      }
      onKeyDown={focusNext}
    />
  </div>

  <div className="del-field">
    <label>GST No</label>
    <input
      className="del-input"
      value={header.invoiceGstNo || ""}
      readOnly
    />
  </div>
</div>

            {showPartyPopup && (
  <div className="party-popup-overlay">
    <div className="party-popup">

      <div className="party-popup-header">
        <span>Party List</span>
        <button onClick={() => setShowPartyPopup(false)}>✕</button>
      </div>
<input
  ref={partyInputRef}
  className="party-popup-search"
  placeholder="Search name / place / mobile"
  value={partySearch}
  onChange={e => {
    setPartySearch(e.target.value);
    setActivePartyIndex(0);
  }}
  onKeyDown={handlePartyKeyDown}
  autoFocus
/>






      <div className="party-popup-list">
  {filteredParties.map((p, i) => (
    <div
      key={p.id}
      className={
        "party-popup-row" + (i === activePartyIndex ? " active" : "")
      }
      tabIndex={-1}
      ref={el => {
        if (i === activePartyIndex && el) {
          el.scrollIntoView({ block: "nearest" });
        }
      }}
      onMouseEnter={() => setActivePartyIndex(i)}
      onClick={() => selectParty(p)}
    >
      <div className="party-name">{p.partyName}</div>
      <div className="party-place">
        {p.place} {p.mobile}
      </div>
    </div>
  ))}
</div>


    </div>
  </div>
)}
{showInvoicePartyPopup && (
  <div className="party-popup-overlay">
    <div className="party-popup">

      <div className="party-popup-header">
        <span> Party List</span>
        <button onClick={() => setShowInvoicePartyPopup(false)}>✕</button>
      </div>

   <input
  ref={invoiceInputRef}
  className="party-popup-search"
  placeholder="Search name / place / mobile"
  value={invoicePartySearch}
  onChange={e => {
    setInvoicePartySearch(e.target.value);
    setInvoiceActiveIndex(0);
  }}
  onKeyDown={handleInvoicePartyKeyDown}
  autoFocus
/>

      <div className="party-popup-list">
  {filteredInvoiceParties.map((p, i) => (
    <div
      key={p.id}
      className={
        "party-popup-row" +
        (i === invoiceActiveIndex ? " active" : "")
      }
      ref={el => {
        if (i === invoiceActiveIndex && el) {
          el.scrollIntoView({ block: "nearest" });
        }
      }}
      onMouseEnter={() => setInvoiceActiveIndex(i)}
      onClick={() => selectInvoiceParty(p)}
    >
      <div className="party-name">{p.partyName}</div>
      <div className="party-place">
        {p.place} {p.mobile}
      </div>
    </div>
  ))}
</div>


    </div>
  </div>
)}



            {/* TABLE */}
            <div className="del-table-wrap">
            <table className="del-table">
              <thead>
                <tr>
                  <th>Item</th><th>HSN</th><th>Qty</th><th>U/A</th>
                  <th>Rate</th><th>Tax %</th><th>Amount</th><th>Remarks</th>
                </tr>
              </thead>
             <tbody>
  {rows.map((r, i) => (
    <tr key={i}>
      <td>
  <input
    className="dc-input"
    data-row={i}
    data-col={0}
    value={r.itemName || ""}
    placeholder="Select Item"
    readOnly
    onKeyDown={e => handleTableEnter(e, i, 0)}
    onClick={() => setPopup({
      open: true,
      field: "item",
      rowIndex: i,
      title: "Select Item",
      options: sortedItems.map(it => it.itemName),
      allowAdd: false
    })}
  />
</td>
      <td>
        <input className="dc-input" value={r.hsnCode} disabled />
      </td>

     <td>
  <input
    className="dc-input"
    value={r.qty}
    data-row={i}
    data-col={2}
    onChange={e => updateRow(i, { qty: e.target.value })}
    onKeyDown={e => handleTableEnter(e, i, 2)}
  />
</td>

<td>
  <input
    className="dc-input"
    value={r.totalKgDisplay || ""}
    disabled
  />
</td>

<td>
  <input className="dc-input" value={r.rate} disabled />
</td>

      <td>
        <input
          className="dc-input"
          value={r.taxPercent}
          data-row={i}
          data-col={4}
          onChange={e => updateRow(i, { taxPercent: e.target.value })}
          onKeyDown={e => handleTableEnter(e, i, 4)}
        />
      </td>

      <td>
        <input className="dc-input" value={r.amount} disabled />
      </td>

      <td>
        <input
          className="dc-input"
          value={r.remarks}
          data-row={i}
          data-col={6}
          onChange={e => updateRow(i, { remarks: e.target.value })}
          onKeyDown={e => handleTableEnter(e, i, 6)}
        />
      </td>
    </tr>
  ))}
</tbody>

            </table>
            </div>

            {/* MOBILE ITEM CARDS */}
<div className="del-mobile-items">

  {rows.map((r, i) => (

    <div key={i} className="del-item-card">

      <div className="item-row">
        <label>Item</label>
       <input
  value={r.itemName || ""}
  placeholder="Select Item"
  readOnly
  onClick={() => setPopup({
    open: true,
    field: "item",
    rowIndex: i,
    title: "Select Item",
    options: sortedItems.map(it => it.itemName),
    allowAdd: false
  })}
/>
      </div>

      <div className="item-row">
        <label>HSN</label>
        <input value={r.hsnCode} readOnly />
      </div>

      <div className="item-row">
        <label>Qty</label>
        <input
          value={r.qty}
          onChange={e => updateRow(i,{qty:e.target.value})}
        />
      </div>

      <div className="item-row">
        <label>U/A</label>
        <input value={r.totalKgDisplay || ""} readOnly />
      </div>

      <div className="item-row">
        <label>Rate</label>
        <input value={r.rate} readOnly />
      </div>

      <div className="item-row">
        <label>Tax %</label>
        <input
          value={r.taxPercent}
          onChange={e => updateRow(i,{taxPercent:e.target.value})}
        />
      </div>

      <div className="item-row">
        <label>Amount</label>
        <input value={r.amount} readOnly />
      </div>

      <div className="item-row">
        <label>Remarks</label>
        <input
          value={r.remarks}
          onChange={e => updateRow(i,{remarks:e.target.value})}
        />
      </div>

    </div>

  ))}

</div>

<button
className="mobile-add-item"
onClick={addNewRow}
>
+ Add Item
</button>
{/* ===== TOTAL SECTION ===== */}
<div className="del-summary">

  <div className="del-summary-row">

    <div className="summary-field">
      <label>Qty</label>
      <input value={totalQty} readOnly />
    </div>

    <div className="summary-field">
      <label>Tot U/A</label>
      <input value={totalKg.toFixed(2)} readOnly />
    </div>

    <div className="summary-field">
      <label>Bill Amount</label>
      <input value={billAmount.toFixed(2)} readOnly />
    </div>

    <div className="summary-field">
      <label>Tax</label>
      <input value={totalTax.toFixed(2)} readOnly />
    </div>

  </div>

  <div className="del-summary-bottom">

    <div className="summary-field discount">
      <label>Discount</label>
      <input
        type="number"
        value={header.discount || ""}
        onChange={e =>
          setHeader(h => ({
            ...h,
            discount: Number(e.target.value || 0)
          }))
        }
      />
    </div>

    <div className="summary-field total">
      <label>Total</label>
      <input value={finalTotal.toFixed(2)} readOnly />
    </div>

  </div>

</div>
            <div className="del-actions">
              <button className="del-btn" onClick={handleNew}>NEW</button>
              <button className="del-btn del-btn-primary" onClick={handleSave}>SAVE</button>
              <button className="del-btn" onClick={openAllDcPopup}>LIST</button>
              <button className="del-btn" onClick={goHome}>EXIT</button>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="del-right">
          <div className="del-right-title">Delivery List</div>

          <div className="del-search-row">
            <input className="del-search-input" placeholder="Search party..."
              value={search} onChange={e => setSearch(e.target.value)} />
          </div>

          <div className="del-list">
  {mergedList.map(d => (
    <div
  key={d.partyName}
  className="del-list-row"
onClick={() => {
  openDeliveryPopup(d.partyName);

  if (window.innerWidth <= 768) {
    setMobileTab("entry");
  }
}}

>

      <div className="del-list-top">
        <span className="del-list-dc">PARTY</span>
      </div>

      <div className="del-list-party">{d.partyName}</div>

      <div className="del-list-meta">
        ₹ {d.totalAmount.toFixed(2)}
      </div>
    </div>

    
  ))}
</div>
{(isPrinting || showPreview) && printData?.deliveries?.length > 0 && (() => {

  const billAmount = printData.items.reduce((s, it) => {
    const qty = Number(it.qty || 0);
    const rate = Number(it.rate || 0);
    const tax = qty * rate * (Number(it.taxPercent || 0) / 100);
    return s + qty * rate + tax;
  }, 0);

  const printDiscount = Number(header.discount || 0);
  const printTotalAmount = billAmount - printDiscount;

  const totalTax = printData.items.reduce((sum, it) => {
    const qty = Number(it.qty || 0);
    const rate = Number(it.rate || 0);
    const taxPercent = Number(it.taxPercent || 0);
    return sum + (qty * rate * taxPercent / 100);
  }, 0);

  return (
    <div className={showPreview ? "preview-overlay" : "print-area"}>

      {showPreview && (
        <div className="preview-toolbar">
          <button className="preview-print-btn"onClick={() => {
  setShowPreview(false);
  setIsPrinting(true);
  setTimeout(() => {
    window.print();
    setIsPrinting(false);
    setPrintData(null);
    setShowDeliveryPopup(true);  // 🔥 reopen DC popup after print
  }, 100);
}}>🖨️ PRINT</button>
          <button className="preview-close-btn" onClick={() => {
  setShowPreview(false);
  setPrintData(null);
  setShowDeliveryPopup(true);  // 🔥 reopen DC popup
}}>✕ CLOSE</button>
        </div>
      )}

      <div className="bill-page">

        {/* ================= HEADER ================= */}
        <div className="bill-header">
          <div className="bill-header-top">
            <div className="bill-gstin">
              GSTIN : 33CLPWM2106A1ZG
            </div>
            <div className="bill-header-center">
              <div className="bill-title">ORANGE TRADINGS</div>
              <div className="bill-sub">
                (Naga Maida, Atta, Rava Whole Sale Dealer)<br />
                Dharapuram Road, Tiruppur – 641 608
              </div>
            </div>
            <div className="bill-phone">
              Cell : +91 8300045544<br />
              +91 9965647744
            </div>
          </div>
        </div>

        {/* ================= TO + INVOICE ================= */}
        <div className="bill-mid">
          <div className="bill-to">
            <b>To M/s :</b><br />
            {printData.deliveries[0].partyName}<br />
            Phone : {printData.mobileNo || "-"}<br />
            Gst No : {printData.gstin !== "" ? printData.gstin : "CUSTOMER"}
          </div>

          <div className="bill-invoice">
            <div className="bill-invoice-title">INVOICE</div>
            <div className="bill-invoice-customer">
              Customer Name : <b>{printData.deliveries[0].partyName}</b>
            </div>
            <table className="bill-invoice-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {printData.deliveries.map((d, i) => (
                  <tr key={i}>
                    <td>{d.dcNo}</td>
                    <td>{new Date(d.deliveryDate).toLocaleDateString("en-GB")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      {/* ================= ITEMS ================= */}
{(() => {
const partyGstin = printData?.gstin || header.gstin || "";
const partyStateCode = partyGstin.replace(/\s/g, "").substring(0, 2);
const OUR_STATE = "33";
const isIntraState =
  !partyGstin ||
  partyGstin === "CUSTOMER" ||
  partyStateCode === OUR_STATE;

const hasTax = printData.items.some(it => Number(it.taxPercent || 0) > 0);

  return (
    <table className="bill-table">
      <thead>
        <tr>
          <th>S.No</th>
          <th>PARTICULARS</th>
          <th>HSN</th>
          <th>QTY</th>
          <th>U/A</th>
          <th>RATE</th>
        {hasTax && isIntraState && <th>CGST</th>}
{hasTax && isIntraState && <th>SGST</th>}
{hasTax && <th>{isIntraState ? "TAX" : "IGST"}</th>}
          <th>AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        {printData.items.map((it, i) => {
          const qty  = Number(it.qty  || 0);
          const rate = Number(it.rate || 0);
          const tp   = Number(it.taxPercent || 0);
          const tax  = qty * rate * tp / 100;
          const cgst = tax / 2;
          const sgst = tax / 2;
          const amt  = qty * rate + tax;
          const ua   = Number(it.totalWeightGrams || 0);
          const itemMaster = items.find(
            x => String(x.id) === String(it.itemId)
          );
          const unit = itemMaster ? itemMaster.unitType : "";

          return (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{it.itemName}</td>
              <td>{it.hsnCode}</td>
              <td className="num">{qty}</td>
              <td className="num">{ua.toFixed(2)} {unit}</td>
              <td className="num">{rate.toFixed(2)}</td>
              {hasTax && isIntraState && <td className="num">{cgst.toFixed(2)}</td>}
{hasTax && isIntraState && <td className="num">{sgst.toFixed(2)}</td>}
{hasTax && <td className="num">{tax.toFixed(2)}</td>}
              <td className="num">{amt.toFixed(2)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
})()}

       {/* ================= BOTTOM ================= */}
{(() => {
  const hasTax = printData.items.some(
    it => Number(it.taxPercent || 0) > 0
  );

  return (
    <div className="bill-bottom">
      <div className="bill-box">
        <div />
        <div className="bill-box-right">
          <div>Discount : {printDiscount.toFixed(2)}</div>
          {hasTax && <div>Tot Tax : {totalTax.toFixed(2)}</div>}
          <div>Bill Amnt : {billAmount.toFixed(2)}</div>
        </div>
      </div>

      <div className="bill-rupees-row">
        <div className="bill-rupees-text-left">
          Rupees : {numberToWords(printTotalAmount)} only.
        </div>
        <div className="bill-rupees-text-right">
          Total Amnt : {printTotalAmount.toFixed(2)}
        </div>
      </div>

      <div className="bill-footer">
        <div className="bill-footer-left">
          <ol>
            <li>We are not responsible for any loss or damage in transit.</li>
            <li>Please check quality and quantity before consumption.</li>
            <li>Payment after due date attracts interest @ 24% P.A.</li>
            <li>Subject to Tiruppur Jurisdiction.</li>
          </ol>
          <div className="bill-sign">
            Prepared By <span>Receivers Sign</span>
          </div>
        </div>
        <div className="bill-footer-right">
          <p>
            We hereby certify that the company registration under GST Act 2017
            is in force and this transaction is covered under this bill.
          </p>
          <div className="bill-auth">
            For <b>ORANGE TRADINGS</b><br />
            Authorised Signatory
          </div>
        </div>
      </div>
    </div>
  );
})()}
            </div>
          </div>
      

  
    
  );
})()}
{showDeliveryPopup && (
  <div className="dp-overlay">
    <div className="dp-box">

      {/* HEADER */}
      <div className="dp-header">
       <span>{popupTitle}</span>
        <button onClick={() => setShowDeliveryPopup(false)}>✕</button>
      </div>

      {/* TABLE */}
      <div className="dp-table-wrap">
        <table className="dp-table">
          <thead>
  <tr>
    <th className="dp-check-col"></th>
    <th>DC No</th>
    <th>Date</th>
    <th>Party</th>
    <th>Qty</th>
    <th>U/A</th>
    <th>Amount</th>
  </tr>
</thead>

          <tbody>
          {popupData.map((d, i) => {
              const totalQty = (d.items || []).reduce(
                (s, it) => s + Number(it.qty || 0),
                0
              );

              return (
               <tr
  key={d.id}
  className={
    selectedDcIds.includes(d.id)
      ? "dp-row active"
      : "dp-row"
  }
>
  <td className="dp-check-col">
    <input
      type="checkbox"
      checked={selectedDcIds.includes(d.id)}
      onChange={() => {
        setSelectedDcIds(prev =>
          prev.includes(d.id)
            ? prev.filter(x => x !== d.id)
            : [...prev, d.id]
        );
      }}
      onClick={e => e.stopPropagation()}
    />
  </td>

  <td>{d.dcNo}</td>
  <td>{d.deliveryDate}</td>
  <td>{d.partyName}</td>
  <td style={{ textAlign: "right" }}>{totalQty}</td>
 <td style={{ textAlign: "right" }}>
  {(() => {
    const items = d.items || [];

    if (!items.length) return "";

  const itemMaster = items.find(x => x.id === items[0].itemId);
const unit = itemMaster?.unitType || "";

    const total = items.reduce(
      (s, it) => s + Number(it.totalWeightGrams || 0),
      0
    );

    return `${total} ${unit}`;
  })()}
</td>
  <td style={{ textAlign: "right" }}>{d.totalAmount}</td>
</tr>

              );
            })}
          </tbody>
        </table>
      </div>

      {/* ACTIONS */}
      <div className="dp-actions">
        <button
   onClick={() => {
  const deliveriesToPrint =
    selectedDcIds.length > 0
      ? popupData.filter(d => selectedDcIds.includes(d.id))
      : popupData;

  if (!deliveriesToPrint.length) {
    alert("No DC available to print");
    return;
  }

  const firstDelivery = deliveriesToPrint[0];
  const party = parties.find(p => p.id === firstDelivery.partyId) || {};

  setPrintData({
    deliveries: deliveriesToPrint,
    items: mergeItemsFromDeliveries(deliveriesToPrint),
    gstin: party.gstin || "",
    mobileNo: party.mobileNo || ""
  });

  // 🔥 DON'T close DC popup — keep it in background
  setShowPreview(true);
}}
        >
          PRINT
        </button>
         <button onClick={handleWhatsappSelected}>WHATSAPP</button>
         <button onClick={handlePrintList}>PRINT LIST</button>
        <button
          onClick={() =>
            setSelectedDcIds(popupData.map(d => d.id))
          }
        >
          SELECT ALL
        </button>

        <button
  onClick={() => {
    if (selectedDcIds.length !== 1) {
      alert("Please select exactly one DC");
      return;
    }

    const dcId = selectedDcIds[0];

    loadDelivery(dcId);
    setShowDeliveryPopup(false);
    setSelectedDcIds([]);
  }}
>
  UPDATE
</button>


        <button onClick={() => setShowDeliveryPopup(false)}>
          EXIT
        </button>
      </div>

    </div>
  </div>
)}

</div>
</div>

  <div className="del-mobile-bottom">

<button
className={mobileTab==="list"?"active":""}
onClick={()=>setMobileTab("list")}
>
Delivery List
</button>

<button
className={mobileTab==="entry"?"active":""}
onClick={()=>setMobileTab("entry")}
>
Entry
</button>

</div>

<button
className="mobile-add-btn"
onClick={()=>setMobileTab("entry")}
>
+
</button>

{popup.open && (

<SelectPopup
title={popup.title}
options={popup.options}
allowAdd={popup.allowAdd}

onSelect={(val)=>{
handlePopupSelect(val);
}}

onClose={()=>setPopup({...popup,open:false})}

/>

)}
    </div>
      
           
      
 

  )


  
}
